import { Injectable } from '@angular/core';
import { Effect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { fromAdUser } from '../reducers';
import { adUserActions } from '../actions';
import { MsGraphApiService } from '@content-platform/web-angular-administration-shared-data-access-ms-graph-api';

@Injectable()
export class AdUserEffects {
  constructor(
    private dataPersistence: DataPersistence<{ adUser: fromAdUser.AdUserState }>,
    private api: MsGraphApiService
  ) {}

  @Effect()
  loadUser$: Observable<any> = this.dataPersistence.fetch(adUserActions.LOAD_AD_USER, {
    run: (action: adUserActions.LoadAdUser) => {
      const principalName = fromAdUser.parseUserEmail(action.payload);
      return this.api
        .getFullUserDetails(principalName)
        .pipe(map(user => new adUserActions.LoadAdUserSuccess(user)));
    },
    onError: (action: adUserActions.LoadAdUser, error) => {
      return new adUserActions.LoadAdUserFailed({
        error,
        message: `Unable to load Active Directory user profile for ${action.payload}`
      });
    }
  });
}
